import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { userActions, HeaderNavAction } from "../actions";
import SvgNew from "../../Member/layouts/SvgNew";
const Sidebar = () => {
    const dispatch = useDispatch();

    const [headerNev, setHeaderNev] = useState(false);
    const [menuKey, setMenuKey] = useState(1);
    const HeaderNav = useSelector((state) => state.headerNav);
    const SideBarState = useSelector((state) => state.SideBar);
    const { pathname } = useLocation();
    const {
        memlogout,
        memchangepass,
        invoice,
    } = SvgNew;
    useEffect(() => {
        // console.log(ListMenuMember.find((val) => val.link == pathname).name);
        setMenuKey(ListMenuMember.find((val) => val.link == pathname).key);
    }, []);

    const ListMenuMember = [
        // {
        //     link: "/membergroup/dashboard",
        //     id: "1",
        //     key: "1",
        //     name: "หน้าแรก",
        //     // icon: memstatus,
        // },
        {
            link: "/membergroup/keeprep",
            id: "2",
            key: "2",
            name: "งบหน้าเรียกเก็บ",
            icon: invoice,
        },
        {
            link: "/membergroup/delivery_book",
            id: "3",
            key: "3",
            name: "หนังสือนำส่ง",
            icon: memlogout,
        },
        {
            link: "/membergroup/summarize_rep",
            id: "4",
            key: "4",
            name: "สรุปยอดเรียกเก็บ",
            icon: memlogout,
        },
        {
            link: "/membergroup/password",
            id: "5",
            key: "5",
            name: "เปลี่ยนรหัสผ่าน",
            icon: memchangepass,
        },
        {
            link: "/membergroup/guide_group",
            id: "6",
            key: "6",
            name: "แนวปฏิบัติของตัวแทนหน่วย",
            icon: memlogout,
        },
    ];

    return (
        <Fragment>
            <aside className="pt-12 z-20 hidden w-64 overflow-y-auto bg-gray-50 lg:block flex-shrink-0 fixed h-screen">
                <ul className="mt-3">
                    {ListMenuMember.map((val, i) => {
                        return (
                            <LiTailwindcss
                                to={val.link}
                                icon={val.icon}
                                name={val.name}
                                title={""}
                                id={val.id}
                                key={i}
                                c_key={menuKey}
                            />
                        );
                    })}
                    <li className="-intro-x relative px-3 py-2 cursor-pointer hover:bg-[#90e0ef] transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-110">
                        <div
                            onClick={() => dispatch(userActions.logout())}
                            className="inline-flex items-center w-full
            text-gray-800
            text-sm font-semibold transition-colors duration-150
             hover:text-gray-800

            "
                        >
                            <div
                                className={`p-1 rounded-full bg-gradient-to-tr
                     transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110
                    group-hover:from-gray-200 group-hover:via-custom-50 group-hover:to-custom-100
                    from-custom-200 via-custom-100  to-custom-400
                      shadow-md`}
                            >
                                {/* <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    x="0px"
                                    y="0px"
                                    className="w-7 h-7 "
                                    viewBox="0 0 100 100"
                                    style={{
                                        enableBackground: "new 0 0 100 100",
                                    }}
                                    xmlSpace="preserve"
                                    dangerouslySetInnerHTML={
                                        {
                                            __html: memlogout,
                                        }
                                    }
                                ></svg> */}
                            </div>
                            <h2 className="ml-4 mb-0 text-base">ออกจากระบบ</h2>
                        </div>
                    </li>
                </ul>
                <div className="border-b-4 p-2 border-green-300 m-auto flex w-4/6" />

                <div
                    className="-intro-x inline-flex items-center w-full mt-2
                    px-1
            text-gray-800
            text-sm font-semibold transition-colors duration-150
             hover:text-gray-800
            "
                >
                    <Link to={`/home`}>
                        <h5 className="ml-4 text-gray-800 text-sm lg:text-base">
                            <i className="fas fa-reply fa-lg"></i>&nbsp;
                            กลับหน้าหลัก
                        </h5>
                    </Link>
                </div>
            </aside>
            {HeaderNav.opened && (
                <Fragment>
                    <div
                        className="fixed inset-0 z-10 flex items-end bg-black bg-opacity-50 sm:items-center sm:justify-center"
                        onClick={() => {
                            // setHeaderNev(true);
                            dispatch(
                                HeaderNavAction.onToggleOpened(HeaderNav.opened)
                            );
                        }}
                    ></div>
                    <aside
                        className="fixed inset-y-0 z-50 flex-shrink-0 w-64 mt-14 overflow-y-auto bg-white  lg:hidden"
                        onClick={() => {
                            // setHeaderNev(true);
                            dispatch(
                                HeaderNavAction.onToggleOpened(
                                    HeaderNav.opened
                                )
                            );
                        }}
                    >
                        {/* py-4 */}
                        <div className=" text-gray-500 ">
                            <ul className="mt-3">
                                {ListMenuMember.map((val, i) => {
                                    return (
                                        <LiTailwindcssMoblie
                                            to={val.link}
                                            icon={val.icon}
                                            name={val.name}
                                            title={""}
                                            id={val.id}
                                            key={i + 1}
                                            c_key={menuKey}
                                        />
                                    );
                                })}
                                <li className="-intro-x relative px-3 py-2 cursor-pointer hover:bg-sky-200    transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-110">
                                    <div
                                        onClick={() =>
                                            dispatch(userActions.logout())
                                        }
                                        className="inline-flex items-center w-full
                                        cursor-pointer text-gray-800 text-sm font-semibold transition-colors duration-150 hover:text-gray-800"
                                    >
                                        <div
                                            className={`p-1 rounded-full bg-gradient-to-tr transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110 group-hover:from-gray-200 group-hover:via-custom-50 group-hover:to-custom-100 from-custom-200 via-custom-100  to-custom-400 shadow-md`}
                                        >
                                            {/* <svg
                                                version="1.1"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                x="0px"
                                                y="0px"
                                                className="w-7 h-7 "
                                                viewBox="0 0 100 100"
                                                style={{
                                                    enableBackground:
                                                        "new 0 0 100 100",
                                                }}
                                                xmlSpace="preserve"
                                                dangerouslySetInnerHTML={{
                                                    __html: memlogout,
                                                }}
                                            ></svg> */}
                                        </div>
                                        <h2 className="ml-4 mb-0 text-base">
                                            ออกจากระบบ
                                        </h2>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </aside>
                </Fragment>
            )}
        </Fragment>
    );
};

const LiTailwindcssMoblie = ({
    to,
    icon,
    name,
    title,
    id,
    key,
    c_key,
    ...rest
}) => {
    return (
        <li
            className={`-intro-x relative px-3 py-2 ${id == (c_key && c_key) ? "bg-custom-200 " : ""
                }
        hover:bg-custom-200
        `}
            key={id}
        >
            {id == c_key && c_key && (
                <Fragment>
                    <span
                        className="absolute inset-y-0 left-0 w-1 bg-custom-600 rounded-tr-lg rounded-br-lg"
                        aria-hidden="true"
                    ></span>
                </Fragment>
            )}

            <Link
                className="inline-flex text-gray-800 items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 "
                to={`${to}`}
            >
                <div
                    className={`p-1 rounded-full bg-gradient-to-tr
                 transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110
                group-hover:from-gray-200 group-hover:via-custom-50 group-hover:to-custom-100
                ${id == (c_key && c_key)
                            ? "from-gray-200 via-custom-50 to-custom-100"
                            : "from-custom-200 via-custom-100  to-custom-400 "
                        }
                  shadow-md`}
                >
                    {/* <svg
                        version="1.1"
                        xmlns="https://www.w3.org/2000/svg"
                        xmlnsXlink="https://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        className="w-7 h-7 "
                        viewBox="0 0 100 100"
                        style={{ enableBackground: "new 0 0 100 100" }}
                        xmlSpace="preserve"
                        dangerouslySetInnerHTML={{ __html: icon }}
                    ></svg> */}
                </div>

                <h2 className="ml-4 text-base">{name}</h2>
            </Link>
        </li>
    );
};

const LiTailwindcss = ({ to, icon, name, id, c_key }) => {
    return (
        <li
            className={`-intro-x relative px-3 py-2 group
        transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-110
        hover:shadow
        ${id == (c_key && c_key)
                    ? "bg-[#90e0ef] underline"
                    : "hover:bg-[#3CCF4E]"
                }

        `}
            key={id}
        >
            {id == c_key && c_key && (
                <Fragment>
                    <span
                        className="absolute inset-y-0 left-0 w-1 bg-custom-600 rounded-tr-lg rounded-br-lg"
                        aria-hidden="true"
                    ></span>
                </Fragment>
            )}
            <Link
                to={`${to}`}
                className="inline-flex items-center w-full
        text-gray-800
        text-sm font-semibold transition-colors duration-150
         hover:text-gray-800
        "
            >
                <div
                    className={`p-1 rounded-full bg-gradient-to-tr
                 transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110
                group-hover:from-gray-200 group-hover:via-custom-50 group-hover:to-custom-100
                    ${id == (c_key && c_key)
                            ? "from-gray-200 via-custom-50 to-custom-100"
                            : "from-custom-200 via-custom-100  to-[#204792]"
                        }
                  shadow-md`}
                >
                    {/* <svg
                        version="1.1"
                        xmlns="https://www.w3.org/2000/svg"
                        xmlnsXlink="https://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        className="w-7 h-7 "
                        viewBox="0 0 100 100"
                        style={{ enableBackground: "new 0 0 100 100" }}
                        xmlSpace="preserve"
                        dangerouslySetInnerHTML={{ __html: icon }}
                    ></svg> */}
                </div>
                <button className="ml-4 text-base text-start"> {name}</button>
            </Link>
        </li>
    );
};

export default Sidebar;
